import React from "react";
import Common from "../../Common";
import { Link, Redirect } from "react-router-dom";
import Header from "../../Header";
import Form from "react-jsonschema-form";
import { systemVariables } from "./systemVariables";
import ToolBarNotification from "../editor/ToolBarNotification";
import Back from "../UI/Back";
import Select from "react-select";
import Creatables from "./Creatables";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { CKEditor } from "@ckeditor/ckeditor5-react";
class AddNotifications extends Common {
  constructor(props) {
    super(props);
    var has_local_data = this.getFromStorage("encdata") ? 1 : 0;
    var localdata = has_local_data
      ? this.decrypt(this.getFromStorage("encdata"), 0)
      : "";
    this.state = {
      apiUrl: this.decryptconfigdata("apiUrl"),
      isLoading: true,
      filteredList: [],
      filteredData: [],
      role: has_local_data ? localdata.data.role : [],
      role_uuid: has_local_data ? localdata.data.role_id : "",
      localdata: localdata,
      message_type: "",
      message: "",
      data: [],
      fields: {},
      notificationData: {},
      notificationCode: "",
      notificationName: "",
      notificationContent: "",
      notificationSendTo: "",
      notificationSendCC: "",
      notificationSubject: "",
      error_message: "",
      error: "",
      formData: [],
      notificationSendToOriginalArray: {},
      finalData: {},
      open: false,
      sendTo: "",
      systemVariablesList: [],
      systemVariablesData: systemVariables,
      sendToDeleted: [],
      sendCCDeleted: [],
      app_token: props.location.state ? props.location.state.app_token : null,
      attribute_set_key: props.location.state
        ? props.location.state.attribute_set_key
        : null,
      attribute_set_name: props.location.state
        ? props.location.state.attribute_set_name
        : null,
      event_name: props.location.state ? props.location.state.event_name : null,
      add_notification_data: [],
      event_listing: [],
      notification_name: "",
      event_id: "",
      attribute: [],
      creatableInputFrom: "",
      creatableInputTo: "",
      creatableInputCC: "",
      isChecked: false,
      toolbarData: [],
      errors: {},
      variablename: "{$variablename}",
      variable_name: "$variablename",
    };
    this.schema = {
      type: "object",
      "ui:formButtons": { submit: "Envoyer" },
    };
    this.onEditorChange = this.onEditorChange.bind(this);
    this.addTags = this.addTags.bind(this);
    this.onChangeSubject = this.onChangeSubject.bind(this);
    this.openPopop = this.openPopop.bind(this);
    this.config = {};
    this.config.allowedContent = true;
    this.config.coreStyles_bold = {
      // For Fixing the Bold Issue
      element: "font",
      attributes: { style: "font-weight: bold;" },
      overrides: "strong",
    };
  }
  componentDidMount() {
    document.title = "Settings | Notifications";
    if (!localStorage.getItem("userLogin")) {
      this.setState({ redirect: true });
    }
    let isLoggedin = this.checklogion();
    if (isLoggedin == false) {
      this.props.history.push("/login");
    }

    fetch(this.state.apiUrl + "create-notification", {
      method: "POST",
      body: JSON.stringify({
        token: this.state.localdata.token,
        app_token: this.state.app_token,
        attribute_set_key: this.state.attribute_set_key,
      }),
    })
      .then((response) => response.json())
      .then((res) => {
        this.setState({
          add_notification_data: res,
          event_listing: res.event_listing,
          attribute: res.attribute,
        });
      });

    // $("#system_var_search").on("keyup", function () {
    //   var value = $(this).val();
    //   console.log("system var", value);
    //   $("#system_variable_att tr").filter(function () {
    //     $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
    //   });
    // });
  }
  cancelAlert = () => {
    this.setState({
      open: false,
    });
  };
  openPopop = (datas) => {
    this.setState({
      open: !this.state.open,
    });
  };
  closeModal() {
    this.setState({
      open: false,
    });
  }

  onChangeSubject(e) {
    var formData = this.state.formData;
    var subject = e.target.value;
    formData["subject"] = subject;
    this.setState({
      formData: formData,
    });
  }
  onEditorChange(evt) {
    var formData = this.state.formData;
    var ckContent = evt.editor.getData();
    this.setState({
      notificationContent: ckContent,
    });
  }
  checkEmail(str) {
    var emailformat = true;
    let filter =
      /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (!filter.test(str)) {
      emailformat = false;
    } else {
      emailformat = true;
    }
    return emailformat;
  }

  handleValidation() {
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;
    if (!fields["notification_name"]) {
      formIsValid = false;
      errors["notification_name"] = "This field is required.";
    }
    if (!fields["event_id"]) {
      formIsValid = false;
      errors["event_id"] = "This field is required.";
    }
    if (!fields["notificationSubject"]) {
      formIsValid = false;
      errors["notificationSubject"] = "This field is required.";
    }
    if (!fields["creatableInputTo"]) {
      formIsValid = false;
      errors["creatableInputTo"] = "This field is required.";
    }
    this.setState({ errors: errors });
    return formIsValid;
  }

  changeTags(event) {
    if (event.key === "Backspace" || event.key === "Delete") {
      var messageTag = "";
      this.setState({
        messageSendToTag: messageTag,
        messageSendCcTag: messageTag,
      });
    }
  }
  addTags(event) {
    var notificationData = this.state.notificationSendTo;
    if (event.key === "Enter" && event.target.value !== "") {
      var sendToTag = event.target.value;
      if (
        sendToTag.startsWith("$") != false ||
        sendToTag.endsWith(".com") != false
      ) {
        notificationData.push(event.target.value);
        this.setState({
          notificationSendTo: notificationData,
        });
        event.target.value = "";
      } else {
        var messageTag =
          "Wrong Input!! Enter system variable starting with $ or email Id";
        this.setState({
          messageSendToTag: messageTag,
        });
      }
    }
  }
  removeTags(index) {
    var notificationData = this.state.notificationSendTo;
    notificationData = [
      ...notificationData.filter(
        (tag) => notificationData.indexOf(tag) !== index
      ),
    ];
    this.setState({
      notificationSendTo: notificationData,
    });
  }
  addCCTags(event) {
    var notificationData = this.state.notificationSendCC;
    if (event.key === "Enter" && event.target.value !== "") {
      var sendCCTag = event.target.value;
      if (
        sendCCTag.startsWith("$") != false ||
        sendCCTag.endsWith(".com") != false
      ) {
        notificationData = [...notificationData, event.target.value];
        this.setState({
          notificationSendCC: notificationData,
        });
        event.target.value = "";
      } else {
        var messageTag =
          "Wrong Input!! Enter system variable starting with $ or email Id";
        this.setState({
          messageSendCcTag: messageTag,
        });
      }
    }
  }
  removeCCTags(index) {
    var notificationData = this.state.notificationSendCC;
    notificationData = [
      ...notificationData.filter(
        (tag) => notificationData.indexOf(tag) !== index
      ),
    ];
    this.setState({
      notificationSendCC: notificationData,
    });
  }
  onToggleCC() {
    var obj = document.getElementById("showcc");
    if (obj.classList.contains("collapsed")) {
      obj.innerHTML = "CC";
    } else {
      obj.innerHTML = "CC";
    }
  }
  onChangeCreatableInputTo = (value) => {
    this.setState({
      creatableInputTo: value,
    });
  };
  onChangeCreatableInputCC = (value) => {
    this.setState({
      creatableInputCC: value,
    });
  };
  handleNotificationName = (event) => {
    this.setState({
      notification_name: event.target.value,
    });
  };
  onChangeEvent = (value) => {
    this.setState({
      event_id: value.id,
    });
  };
  handleSubject = (event) => {
    this.setState({
      notificationSubject: event.target.value,
    });
  };
  toolbarData = (data) => {
    this.setState({
      toolbarData: data.getData(),
    });
  };
  handleCheckBox = (event) => {
    this.setState({
      isChecked: event.target.checked,
    });
  };
  handleFormSubmit = () => {
    const sendCC = [];
    const sendTo = [];
    const userCC = this.state.creatableInputCC.length
      ? this.state.creatableInputCC.map((item) =>
          sendCC.push(Object.values(item)[1])
        )
      : null;
    const userTo = this.state.creatableInputTo.length
      ? this.state.creatableInputTo.map((item) =>
          sendTo.push(Object.values(item)[1])
        )
      : null;
    let newArr_To = [];
    let newArr_CC = [];
    let notification_sendTo = sendTo.map((item) => {
      let val = JSON.stringify(item);
      if (val.includes("$") === true) {
        var email_get = `${item}`;
        newArr_To.push(email_get);
      } else {
        newArr_To.push({ user: item, user_name: "" });
      }
    });
    let send_TO_values = JSON.stringify(newArr_To);
    let notification_sendCC = sendCC.map((item) => {
      let val = JSON.stringify(item);
      if (val.includes("$") === true) {
        var get_email = `${item}`;
        newArr_CC.push(get_email);
      } else {
        newArr_CC.push({ user: item, user_name: "" });
      }
    });
    let send_CC_values = JSON.stringify(newArr_CC);
    const send_TO_Final = `{\"cc\":${send_CC_values},\"to\":${send_TO_values},\"bcc\":[]}`;
    this.state.fields["notification_name"] = this.state.notification_name;
    this.state.fields["event_id"] = this.state.event_id;
    this.state.fields["notificationSubject"] = this.state.notificationSubject;
    this.state.fields["creatableInputTo"] = this.state.creatableInputTo;

    if (this.handleValidation()) {
      console.log("Data Has been submitted");
    } else {
      console.log("This Fields Are required.");
      return false;
    }
    document.getElementById("add_user_btn").innerHTML = "Sending....";
    document.getElementById("add_user_btn").disabled = true;
    fetch(this.state.apiUrl + "addNotification", {
      method: "post",
      body: JSON.stringify({
        event_id: this.state.event_id,
        app_token: this.state.app_token,
        attribute_set_key: this.state.attribute_set_key,
        attachment: this.state.isChecked === true ? 1 : 0,
        content: window.btoa(this.state.toolbarData),
        notification_name: this.state.notification_name,
        send_to: send_TO_Final,
        subject: this.state.notificationSubject,
      }),
    })
      .then((response) => response.json())
      .then((result) => {
        document.getElementById("add_user_btn").innerHTML = "Save";
        document.getElementById("add_user_btn").disabled = false;
        if (result.code == "200") {
          localStorage.setItem("addnotication", 1);
          this.props.history.push({
            pathname:
              "/" + this.state.attribute_set_key + "/manage-notifications",
            state: {
              app_token: this.state.app_token,
              attribute_set_key: this.state.attribute_set_key,
              attribute_set_name: this.state.attribute_set_name,
              show_notification: 1,
            },
          });
        }
      });
  };
  render() {
    const { attribute_set_key, app_token, attribute_set_name } = this.state;
    if (this.state.redirect) {
      return <Redirect to={"/login"} />;
    }
    const { open } = this.state;
    var notification_send_to_Array = Object.values(
      this.state.notificationSendTo
    ).filter((col) => col);
    var notification_cc_Array;
    if (this.state.notificationSendCC != undefined) {
      notification_cc_Array = Object.values(
        this.state.notificationSendCC
      ).filter((col) => col);
    } else {
      notification_cc_Array = [null];
    }
    const event_options = this.state?.event_listing?.map((item) => {
      return item;
    });
    const options = this.state.attribute?.map((item) => {
      return item;
    });
    const creatableValue = this.state.attribute?.map((item) => {
      return item.value;
    });
    return (
      <div
        class="mainContent-panel-wrap"
        style={{
          overflow: "auto",
        }}
      >
        <Header brecum_name="Add Notifications" brecum_page={`Add`} />
        <div class="content-wrapper">
          <div class="wrapper">
            <div class="page-content">
              <p className="col-form-label txt-dark d-flex pb-0">
                <Back
                  name="Back"
                  to={`/${attribute_set_key}/manage-notifications`}
                  state={this.props.location.state}
                  className="txt-dark underline-none"
                />
              </p>
              <br></br>
              <div class="cardRow pt-0">
                <div class="card">
                  <div class="card-body p-2">
                    <div class="title fs-5 mb-4">Add Notification</div>
                    <div class="row g-4 align-items-stretch">
                      <div class="col">
                        <div class="mb-3 row gx-lg-0 gx-xl-3 align-items-center">
                          <label class="col-lg-4 col-xl-4 col-form-label fw-medium txt-dark text-nowrap  _required">
                            Notification Title
                          </label>
                          <div class="col-sm">
                            <input
                              type="text"
                              class="form-control"
                              id=""
                              value={this.state.notification_name}
                              placeholder="Notification Title"
                              onChange={this.handleNotificationName}
                            />
                            <span class="error">
                              {this.state.errors["notification_name"]}
                            </span>
                          </div>
                        </div>
                        <div class="mb-3 row gx-lg-0 gx-xl-3 align-items-center">
                          <label class="col-lg-4 col-xl-4 col-form-label fw-medium txt-dark text-nowrap  _required">
                            Notification Event
                          </label>
                          <div class="col-sm">
                            <Select
                              class="selectpicker w-100 has-invalid"
                              aria-label="Default select example"
                              options={event_options}
                              onChange={this.onChangeEvent}
                            />
                            {/* {event_name_load}
                                             </Select> */}
                            <span class="error">
                              {this.state.errors["event_id"]}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div class="col-auto opacity-50">
                        <div class="vr h-100 mx-2"></div>
                      </div>
                      <div class="col col-lg-6 col-xl-6">
                        <div class="title">Editor</div>
                        <ul
                          class="nav nav-tabs _custom3 border-bottom mb-4 px-0"
                          id="myTab"
                          role="tablist"
                        >
                          <li class="nav-item" role="presentation">
                            <a
                              class="nav-link active"
                              id="email-tab"
                              data-bs-toggle="tab"
                              href="#email"
                              role="tab"
                              aria-controls="email"
                              aria-selected="true"
                            >
                              Email
                            </a>
                          </li>
                        </ul>
                        <Form
                          className="edit-notification-form"
                          schema={this.schema}
                          uiSchema={this.UiSchema}
                          onSubmit={this.formSubmit}
                          formData={this.state.formData}
                        >
                          <div class="tab-content" id="myTabContent">
                            <div
                              class="tab-pane fade show active"
                              id="email"
                              role="tabpanel"
                              aria-labelledby="email-tab"
                            >
                              <div class="section-header mb-3">
                                <div class="title text-capitalize">
                                  Enter email notification details
                                </div>
                              </div>
                              <div class="section-body">
                                <div class="mb-2 row g-2 align-items-center">
                                  <label class="col-lg col-xl col-form-label _required">
                                    To
                                  </label>

                                  <div class="col-lg-10">
                                    <div>
                                      <Creatables
                                        options={options}
                                        onChange={this.onChangeCreatableInputTo}
                                      />
                                    </div>
                                    <span class="error">
                                      {this.state.errors["creatableInputTo"]}
                                    </span>
                                  </div>
                                </div>

                                {/* add cc */}
                                <div class="mb-2 row g-2 align-items-center">
                                  <label class="col-lg col-xl col-form-label">
                                    CC
                                  </label>
                                  <div class="col-lg-10">
                                    <Creatables
                                      options={options}
                                      onChange={this.onChangeCreatableInputCC}
                                    />
                                  </div>
                                </div>

                                <div class="mb-2">
                                  <div class="d-flex justify-content-between my-1">
                                    <label class="form-label _required">
                                      Subject
                                    </label>
                                  </div>
                                  <input
                                    type="text"
                                    class="form-control"
                                    id="exampleInputEmail1"
                                    placeholder="Subject"
                                    value={this.state.notificationSubject}
                                    onChange={this.handleSubject}
                                  />
                                  <span class="error">
                                    {this.state.errors["notificationSubject"]}
                                  </span>
                                </div>
                                <CKEditor
                                  editor={Editor}
                                  data={this.state.toolbarData}
                                  config={{
                                    mention: {
                                      feeds: [
                                        {
                                          marker: "@",

                                          feed: [
                                            {
                                              id: "@subrat",
                                              name: "subrat ranjan panda",
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  }}
                                  onChange={(event, editor) =>
                                    this.toolbarData(editor)
                                  }
                                />
                                <CKEditor />
                              </div>
                            </div>
                          </div>
                          <div class="d-flex justify-content-end my-2">
                            <div class="form-check notification-attachment">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                value={this.state.isChecked}
                                id="flexCheckChecked"
                                onChange={this.handleCheckBox}
                              />
                              <label
                                class="form-check-label"
                                for="flexCheckChecked"
                              >
                                Add Attachment
                              </label>
                            </div>
                            <div
                              class="muBtn _link icon-before txt-dark p-0"
                              data-bs-toggle="modal"
                              data-bs-target="#system-variables-modal"
                              onClick={() =>
                                this.openPopop(this.state.attribute)
                              }
                            >
                              <span class="svg reset">
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M12 1C5.92465 1 1 5.92465 1 12C1 18.0753 5.92465 23 12 23C18.0753 23 23 18.0753 23 12C23 5.92465 18.0753 1 12 1ZM12 5.30435C12.7925 5.30435 13.4348 5.94665 13.4348 6.73913C13.4348 7.53161 12.7925 8.17391 12 8.17391C11.2075 8.17391 10.5652 7.53161 10.5652 6.73913C10.5652 5.94665 11.2075 5.30435 12 5.30435ZM13.913 18.2174H12.9565H11.0435H10.087V17.2609H11.0435V11.0435H10.087V10.087H11.0435H12.9565V11.0435V17.2609H13.913V18.2174Z"
                                    fill="#2F80ED"
                                  />
                                </svg>
                              </span>
                              System variables
                            </div>
                          </div>
                        </Form>
                      </div>
                    </div>
                    <div class="d-flex justify-content-end mt-4">
                      <button
                        class="muBtn _blue _minW"
                        type="submit"
                        id="add_user_btn"
                        onClick={this.handleFormSubmit}
                      >
                        Save
                      </button>
                    </div>
                    {/* {this.state.open === true ? ( */}
                    <div
                      class="modal fade"
                      id="system-variables-modal"
                      tabindex="-1"
                      role="dialog"
                      aria-labelledby="addPersionTitle"
                      aria-hidden="true"
                    >
                      <div
                        class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-md"
                        role="document"
                      >
                        <div class="modal-content">
                          <div class="modal-header pb-2 pt-4 align-items-start">
                            <div class="d-flex flex-column">
                              <h4 class="modal-title">System Variables</h4>
                              <p class="modal-subtitle m-0">
                                To add a system variable please follow below
                                format.
                              </p>
                            </div>
                            <div
                              class="close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </div>
                          </div>

                          <div class="px-4 py-2 mx-2">
                            <div class="searchBox border">
                              <div class="input-group">
                                <div class="input-group-text">
                                  <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
                                      stroke="black"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    ></path>
                                    <path
                                      d="M20.9999 21L16.6499 16.65"
                                      stroke="black"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    ></path>
                                  </svg>
                                </div>
                                <input
                                  type="text"
                                  class="form-control ps-0"
                                  aria-label="Sizing example input"
                                  aria-describedby="inputGroup-sizing-sm"
                                  placeholder="Search"
                                  id="system_var_search"
                                />
                              </div>
                            </div>
                          </div>

                          <div class="modal-body py-0">
                            <div class="table-responsive">
                              <table
                                class="table align-center"
                                id="system_variable_att"
                              >
                                <thead>
                                  <tr>
                                    <th>Variables</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.attribute?.map((item) => {
                                    return (
                                      <tr>
                                        <td class="py-0">
                                          {item === null ? "" : item.value}
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                              <div _ngcontent-c10="" class="note-sec">
                                <h6 _ngcontent-c10="">
                                  Note:{" "}
                                  <span _ngcontent-c10="" class="red">
                                    To add a system variable please follow below
                                    format.
                                  </span>
                                </h6>
                                <ul _ngcontent-c10="">
                                  <li _ngcontent-c10="">
                                    <strong _ngcontent-c10="">
                                      {this.state.variable_name}
                                    </strong>{" "}
                                    for 'To' and 'From' fields
                                  </li>
                                  <li _ngcontent-c10="">
                                    <strong _ngcontent-c10="">
                                      {this.state.variablename}
                                    </strong>{" "}
                                    for 'Subject' and 'Email Content'{" "}
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default AddNotifications;
